import useReveal from "@/hooks/useReveal";

const PACKAGING_IMAGE =
  "https://customer-assets.emergentagent.com/job_afrqa-luxury/artifacts/5fxb2oas_afrqa%20case.PNG";

const ITEMS = [
  {
    title: "Signature Black Box",
    body: "Matte exterior. Magnetic close. Embossed AFRQA™ wordmark.",
  },
  {
    title: "Authenticity Card",
    body: "Numbered 001–300. Signed. Holographic gold-foil seal.",
  },
  {
    title: "Luxury Velvet Pouch",
    body: "Soft-touch black velvet with gold drawcord.",
  },
];

export default function Packaging() {
  const r1 = useReveal();
  const r2 = useReveal();
  return (
    <section
      id="packaging"
      data-testid="packaging-section"
      className="relative bg-[#0a0a0a] py-24 md:py-36"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div
            ref={r1.ref}
            className={`reveal ${r1.inView ? "in-view" : ""} lg:col-span-6 zoom-wrap aspect-[4/5] bg-[#0c0c0c] border border-[#1f1f1f]`}
          >
            <img
              src={PACKAGING_IMAGE}
              alt="AFRQA luxury black and gold packaging"
              className="w-full h-full object-cover"
            />
          </div>
          <div
            ref={r2.ref}
            className={`reveal reveal-delay-1 ${
              r2.inView ? "in-view" : ""
            } lg:col-span-6`}
          >
            <span className="font-label text-[#d4af37]">— The Unboxing —</span>
            <h2 className="mt-4 font-display text-[clamp(1.8rem,4.2vw,3.6rem)] leading-tight tracking-tight text-white">
              Every detail{" "}
              <span className="font-editorial italic gold-text-gradient">
                considered.
              </span>
            </h2>
            <p className="mt-6 text-[#bdbdb7] text-lg leading-relaxed max-w-md font-light">
              Black, gold, marble. A quiet ritual.
            </p>

            <div className="mt-10 space-y-1">
              {ITEMS.map((it, i) => (
                <div
                  key={it.title}
                  className="grid grid-cols-12 gap-4 py-6 border-t border-[#1f1f1f]"
                  data-testid={`packaging-item-${i}`}
                >
                  <div className="col-span-2 font-editorial italic gold-text-gradient text-2xl">
                    0{i + 1}
                  </div>
                  <div className="col-span-10">
                    <p className="font-display text-white text-xl">
                      {it.title}
                    </p>
                    <p className="mt-2 text-[#a3a3a3] leading-relaxed font-light">
                      {it.body}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
